import { useEffect, useState } from "react";
import {
  CircularProgress,
  Typography,
  Grid,
  Button,
  List,
  ListItem,
  Divider,
} from "@mui/material";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import {
  AddressReferenceDropDown,
  AutocompleteDropDown,
  FormFooter,
  MetaTags,
  PageLayout,
  TextInput,
} from "../../components";
import useLocales from "../../hooks/useLocales";
import { Form, Formik, useFormikContext } from "formik";
import { addressInitials } from "../../interfaces/Address";
import { fetcher, infrastructureOptions, isExists, params } from "../../utils";
import { InfrastructureEnum } from "../../utils/enum";
import Swal from "sweetalert2";
import { PhoneLandInput } from "../../components";
import { LoadingButton } from "@mui/lab";
import { useAppDispatch } from "../../app/hooks";
import { ApiSlice } from "../../features/api/Api";
import * as Yup from "yup";

const Home = () => {
  const dispatch = useAppDispatch();
  const { translate } = useLocales();
  const [loader, setLoader] = useState(false);
  const [internetInfrastructure, setInternetInfrastructure] = useState<any[]>(
    []
  );
  const [infrastructureWithAddres, setInfrastructureWithAddres] = useState<
    any[]
  >([]);
  const [infrastructure, setInfrastructure] = useState<any>();
  const [loaderInternet, setLoaderInternet] = useState<boolean>(false);
  const [loaderInternetXdslOrPstn, setLoaderInternetXdslOrPstn] =
    useState<boolean>(false);
  const [loaderAddress, setLoaderAddress] = useState<boolean>(false);
  const [addressByBbkCode, setAddressByBbkCode] = useState<any>();
  const [addressNo, setAddressNo] = useState<any>();
  const [hasSubmitAttempt, setHasSubmitAttempt] = useState(false);

  interface InitialValProps {
    infrastructure: number;
    phone: string;
    devreNo: string | null;
  }

  const initialVal: InitialValProps = {
    infrastructure: InfrastructureEnum.Pstn,
    phone: "",
    devreNo: "",
  };

  const validationSchema = Yup.object().shape({
    infrastructure: Yup.number().required(),
    phone: Yup.string().when("infrastructure", {
      is: InfrastructureEnum.Pstn,
      then: Yup.string()
        .required(translate("required.required_phone"))
        .length(10, translate("errors.phoneNumberLength")),
    }),
    devreNo: Yup.string().when("infrastructure", {
      is: InfrastructureEnum.Xdsl,
      then: Yup.string()
        .required(translate("required.required_devreNo"))
        .length(10, translate("errors.xdslNumberLength")),
    }),
  });

  return (
    <>
      <MetaTags
        title={translate("menu.home")}
        keyword="Isnet, Bayi, Anasayfa"
        description="Bayi Anasayfasi"
      />
      <PageLayout title="BBK Kodu Sorgulama">
        <Formik
          initialValues={addressInitials}
          onSubmit={(val) => console.log(val)}
        >
          {(props) => (
            <Form>
              <Grid container spacing={3}>
                <Grid item md={3} sm={12} xs={12} lg={3}>
                  <AddressReferenceDropDown
                    name="city"
                    label={translate("resources.customers.addresses.city")}
                    reference="fixity/setting/TurkTelekomAddress/get-cities/187cf1ae-023f-ed11-a5f4-005056a2cd35"
                    optionName="name"
                    optionId="turkTelekomId"
                    /* disabled={!isExists(props.values.nationalityId)}
                    skip={!isExists(props.values.nationalityId)} */
                  />
                </Grid>
                <Grid item md={3} sm={12} xs={12} lg={3}>
                  <AddressReferenceDropDown
                    name="town"
                    label={translate("resources.customers.addresses.town")}
                    reference={`fixity/setting/TurkTelekomAddress/get-towns-by-city-id`}
                    query={{ cityId: props.values.city.value }}
                    optionName="name"
                    optionId="turkTelekomId"
                    secondField={{
                      name: "address.addressLocationId",
                      value: "id",
                    }}
                    disabled={!isExists(props.values.city)}
                    skip={!isExists(props.values.city)}
                  />
                </Grid>
                <Grid item md={3} sm={12} xs={12} lg={3}>
                  <AddressReferenceDropDown
                    name="townShip"
                    label={translate("resources.customers.addresses.townShip")}
                    reference={`fixity/setting/TurkTelekomAddress/get-townships-by-town-id`}
                    query={{ TownId: props.values.town.value }}
                    optionName="name"
                    optionId="turkTelekomId"
                    secondField={{
                      name: "address.addressLocationId",
                      value: "id",
                    }}
                    disabled={!isExists(props.values.town)}
                    skip={!isExists(props.values.town)}
                  />
                </Grid>
                <Grid item md={3} sm={12} xs={12} lg={3}>
                  <AddressReferenceDropDown
                    name="village"
                    label={translate("resources.customers.addresses.village")}
                    reference={`fixity/setting/TurkTelekomAddress/get-villages-by-township-id`}
                    query={{ TownShipId: props.values.townShip.value }}
                    optionName="name"
                    optionId="turkTelekomId"
                    secondField={{
                      name: "address.addressLocationId",
                      value: "id",
                    }}
                    disabled={!isExists(props.values.townShip)}
                    skip={!isExists(props.values.townShip)}
                  />
                </Grid>
                <Grid item md={3} sm={12} xs={12} lg={3}>
                  <AddressReferenceDropDown
                    name="district"
                    label={translate("resources.customers.addresses.district")}
                    reference={`fixity/setting/TurkTelekomAddress/get-districts-by-village-id`}
                    query={{ VillageId: props.values.village.value }}
                    optionName="name"
                    optionId="turkTelekomId"
                    secondField={{
                      name: "address.addressLocationId",
                      value: "id",
                    }}
                    disabled={!isExists(props.values.village)}
                    skip={!isExists(props.values.village)}
                  />
                </Grid>
                <Grid item md={3} sm={12} xs={12} lg={3}>
                  <AddressReferenceDropDown
                    name="street"
                    label={translate("resources.customers.addresses.street")}
                    reference={`fixity/setting/TurkTelekomAddress/get-streets-by-district-id`}
                    query={{ DistrictId: props.values.district.value }}
                    optionName="name"
                    optionId="turkTelekomId"
                    secondField={{
                      name: "address.addressLocationId",
                      value: "id",
                    }}
                    disabled={!isExists(props.values.district)}
                    skip={!isExists(props.values.district)}
                  />
                </Grid>
                <Grid item md={3} sm={12} xs={12} lg={3}>
                  <AddressReferenceDropDown
                    name="building"
                    label={translate("resources.customers.addresses.building")}
                    reference={`fixity/setting/TurkTelekomAddress/get-building-numbers-by-street-id`}
                    query={{ StreetId: props.values.street.value }}
                    optionName="name"
                    optionId="turkTelekomId"
                    secondField={{
                      name: "address.addressLocationId",
                      value: "id",
                    }}
                    disabled={!isExists(props.values.street)}
                    skip={!isExists(props.values.street)}
                  />
                </Grid>
                <Grid item md={3} sm={12} xs={12} lg={3}>
                  <AddressReferenceDropDown
                    name="door"
                    label={translate("resources.customers.addresses.door")}
                    reference={`fixity/setting/TurkTelekomAddress/get-door-numbers-by-building-id`}
                    query={{ BuildingId: props.values.building.value }}
                    optionName="name"
                    optionId="turkTelekomId"
                    secondField={{
                      name: "address.addressLocationId",
                      value: "id",
                    }}
                    disabled={!isExists(props.values.building)}
                    skip={!isExists(props.values.building)}
                  />
                </Grid>
                <GetBBKCode setAddressNo={setAddressNo} />
                <Grid item md={3} sm={12} xs={12} lg={3}>
                  <TextInput
                    name="addressDetail.bbkCode"
                    label="BBK Kodu"
                    disabled={true}
                  />
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>

        <FormFooter />
      </PageLayout>
      <PageLayout title="Altyapı Sorgulama">
        <Formik
          initialValues={{ bbkCode: "" }}
          onSubmit={async (val) => {
            setLoaderInternet(true);
            const result = await dispatch(
              ApiSlice.endpoints.create.initiate({
                resource:
                  "fixity/setting/TurkTelekomAddress/internetInfrastructureQuery",
                params: [val.bbkCode],
              })
            );

            const { data: internetInfrastructureQuery }: any = result;
            if (internetInfrastructureQuery.data) {
              setInternetInfrastructure(internetInfrastructureQuery.data);
              setLoaderInternet(false);
            }
            const resultAddressCode = await dispatch(
              ApiSlice.endpoints.get.initiate({
                resource:
                  "fixity/setting/TurkTelekomAddress/getAddressCodeFromBbkCode",
                params: {
                  ...params,
                  filter: {
                    bbkCode: val.bbkCode,
                  },
                },
              })
            );
            const { data: addressCode }: any = resultAddressCode;
            if (addressCode.data) {
              setLoaderAddress(false);
              setAddressByBbkCode(addressCode.data.acikAdres);
            }
          }}
        >
          {(props) => (
            <Form>
              <Grid container spacing={3}>
                <Grid item md={4} sm={12} xs={12} lg={4}>
                  <TextInput name="bbkCode" label="BBK Kodu" />
                </Grid>
                <Grid item md={3} sm={12} xs={12} lg={3}>
                  {loaderInternet ? (
                    <LoadingButton
                      loading
                      variant="contained"
                      style={{ height: "55px" }}
                      fullWidth
                      disabled={loaderInternet}
                    >
                      <span>Sorgula</span>
                    </LoadingButton>
                  ) : (
                    <Button
                      type="submit"
                      variant="contained"
                      style={{ height: "55px" }}
                      fullWidth
                      disabled={loaderInternet}
                    >
                      {loaderInternet ? <CircularProgress /> : "Sorgula"}
                    </Button>
                  )}
                </Grid>
                <Grid item md={12}>
                  {!loaderAddress ? (
                    <Typography>{addressByBbkCode}</Typography>
                  ) : (
                    <CircularProgress />
                  )}
                </Grid>
                <Grid item md={12}>
                  {!loaderInternet ? (
                    <>
                      {internetInfrastructure ? (
                        <List
                          sx={{
                            width: "100%",
                            bgcolor: "background.paper",
                          }}
                        >
                          {internetInfrastructure?.map(
                            (item: any, index: number) => (
                              <>
                                <ListItem alignItems="flex-start" key={index}>
                                  <KeyboardDoubleArrowRightIcon
                                    style={{ width: "15px" }}
                                  />
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    <strong> {item.serviceType} </strong>
                                    {item.santraL_HIZMET_VERILEBILIRLIK
                                      ? ""
                                      : "Santral Hizmet verilemiyor"}{" "}
                                    {item.santraL_HIZMET_VERILEBILIRLIK
                                      ? ` Maks Hız: ${item.hiz} Mbps`
                                      : null}
                                    {item.santraL_HIZMET_VERILEBILIRLIK
                                      ? ` - Santrale Mesafe yaklaşık 
                                      ${item.mesafe} Mt.`
                                      : null}
                                    {item.santraL_HIZMET_VERILEBILIRLIK &&
                                    item.fiber
                                      ? ` - Fiber`
                                      : null}
                                    {item.santraL_HIZMET_VERILEBILIRLIK &&
                                    item.boS_PORT
                                      ? ` - Boş Port bulunmaktadır`
                                      : null}
                                  </Typography>
                                </ListItem>
                                <Divider variant="inset" component="li" />
                              </>
                            )
                          )}
                        </List>
                      ) : null}
                    </>
                  ) : (
                    <CircularProgress />
                  )}
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
        <FormFooter />
      </PageLayout>
      <PageLayout title="Pstn/Xdsl Sorgulama">
        <Formik
          initialValues={initialVal}
          validationSchema={validationSchema}
          validateOnMount={false}
          validateOnChange={hasSubmitAttempt}
          validateOnBlur={hasSubmitAttempt}
          onSubmit={async (val, { validateForm }) => {
            if (!hasSubmitAttempt) {
              setHasSubmitAttempt(true);
              const errors = await validateForm(val);
              if (Object.keys(errors).length > 0) {
                return;
              }
            }

            setLoader(true);
            const value = {
              pstn: Number(val.phone),
              devreNo: Number(val.devreNo),
            };
            fetcher(
              `fixity/order/TTAdress/get-Adress-with-Pstn-XdslNo?${
                val.infrastructure === InfrastructureEnum.Xdsl
                  ? `xdslNo=${value.devreNo}`
                  : ""
              }${
                val.infrastructure === InfrastructureEnum.Pstn
                  ? `pstnNO=${value.pstn}`
                  : ""
              }`,
              "GET",
              null
            )
              .then((response) => {
                if (response?.isAxiosError) {
                  throw response;
                }

                const data = response?.data;

                if (data?.isSuccessful) {
                  if (!data.data?.bbk) {
                    Swal.fire(
                      translate("actions.error"),
                      translate("errors.noBbkFound"),
                      "error"
                    );
                    setInfrastructure("");
                    setInfrastructureWithAddres([]);
                    return;
                  }

                  setLoaderInternetXdslOrPstn(true);
                  setLoader(true);

                  fetcher(
                    "fixity/setting/TurkTelekomAddress/internetInfrastructureQuery",
                    "POST",
                    JSON.stringify([data.data.bbk])
                  )
                    .then((infrastructureResponse) => {
                      if (infrastructureResponse?.isAxiosError) {
                        throw infrastructureResponse;
                      }

                      const infraData = infrastructureResponse?.data;
                      if (infraData.data) {
                        setInfrastructureWithAddres(infraData.data);
                      } else if (infraData?.errors) {
                        Swal.fire(
                          translate("actions.error"),
                          infraData.errors,
                          "error"
                        );
                        setInfrastructureWithAddres([]);
                      }
                    })
                    .catch((error) => {
                      const errorMessage =
                        error?.response?.data?.errors ||
                        error?.message ||
                        translate("errors.infrastructureQueryFailed");
                      Swal.fire(
                        translate("actions.error"),
                        errorMessage,
                        "error"
                      );
                      setInfrastructureWithAddres([]);
                    })
                    .finally(() => {
                      setLoader(false);
                      setLoaderInternetXdslOrPstn(false);
                    });

                  if (data.data.address === "") {
                    fetcher(
                      `fixity/setting/TurkTelekomAddress/getAddressCodeFromBbkCode?bbkCode=${data.data.bbk}`,
                      "GET",
                      null
                    )
                      .then(({ data: addressResponse }) => {
                        if (addressResponse?.isSuccessful) {
                          if (addressResponse.data?.acikAdres) {
                            setInfrastructure(addressResponse.data.acikAdres);
                          }
                        } else if (addressResponse?.errors) {
                          Swal.fire(
                            translate("actions.error"),
                            addressResponse.errors,
                            "error"
                          );
                        }
                      })
                      .catch((error) => {
                        Swal.fire(
                          translate("actions.error"),
                          translate("errors.addressLookupFailed"),
                          "error"
                        );
                      })
                      .finally(() => {
                        setLoaderAddress(false);
                      });
                  } else {
                    setInfrastructure(data.data.address);
                    setLoaderAddress(false);
                  }
                } else if (data?.errors) {
                  Swal.fire(translate("actions.error"), data.errors, "error");
                  setInfrastructure("");
                  setInfrastructureWithAddres([]);
                }
              })
              .catch((error) => {
                const errorMessage =
                  error?.response?.data?.errors ||
                  error?.message ||
                  translate("errors.apiError");
                Swal.fire(translate("actions.error"), errorMessage, "error");
                setInfrastructure("");
                setInfrastructureWithAddres([]);
              })
              .finally(() => {
                setLoader(false);
              });
          }}
        >
          {(props) => (
            <Form>
              <Grid container spacing={3}>
                <Grid item md={3} sm={12} xs={12} lg={3}>
                  <AutocompleteDropDown
                    name="infrastructure"
                    label="Altyapı"
                    options={infrastructureOptions}
                  />
                </Grid>

                <>
                  {props.values.infrastructure === InfrastructureEnum.Pstn && (
                    <Grid item md={3} sm={12} xs={12} lg={3}>
                      <PhoneLandInput
                        name="phone"
                        label="Telefon Numarası"
                        handleChange={(e: any) => {
                          const value = e.target.value.replace(/\D/g, "");
                          if (value.length <= 10) {
                            props.setFieldValue("phone", value);
                          }
                        }}
                      />
                    </Grid>
                  )}

                  {props.values.infrastructure === InfrastructureEnum.Xdsl && (
                    <Grid item md={3} sm={12} xs={12} lg={3}>
                      <TextInput
                        type="number"
                        name="devreNo"
                        label="Devre Numarası"
                        onChange={(e: any) => {
                          const value = e.target.value.replace(/\D/g, "");
                          if (value.length <= 10) {
                            props.setFieldValue("devreNo", value);
                          }
                        }}
                      />
                    </Grid>
                  )}
                </>
                <Grid item md={3} sm={12} xs={12} lg={3}>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{ height: "55px" }}
                    fullWidth
                    disabled={loader || (hasSubmitAttempt && !props.isValid)}
                  >
                    {loader ? <CircularProgress /> : "Sorgula"}
                  </Button>
                </Grid>
                {infrastructure && (
                  <Grid item md={12} sm={12} xs={12} lg={3}>
                    <Typography>
                      <strong> {infrastructure}</strong>
                    </Typography>
                  </Grid>
                )}
                <Grid item md={12} sm={12} xs={12} lg={3}>
                  {!loaderInternetXdslOrPstn ? (
                    <>
                      {infrastructureWithAddres &&
                      (props.values.infrastructure ===
                        InfrastructureEnum.Xdsl ||
                        props.values.infrastructure ===
                          InfrastructureEnum.Pstn) ? (
                        <List
                          sx={{
                            width: "100%",
                            bgcolor: "background.paper",
                          }}
                        >
                          {infrastructureWithAddres?.map(
                            (item: any, index: number) => (
                              <>
                                <ListItem alignItems="flex-start" key={index}>
                                  <KeyboardDoubleArrowRightIcon
                                    style={{ width: "15px" }}
                                  />
                                  <Typography
                                    sx={{ display: "inline" }}
                                    component="span"
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    <strong> {item.serviceType} </strong>
                                    {item.santraL_HIZMET_VERILEBILIRLIK
                                      ? ""
                                      : "Santral Hizmet verilemiyor"}{" "}
                                    {item.santraL_HIZMET_VERILEBILIRLIK
                                      ? ` Maks Hız: ${item.hiz} Mbps`
                                      : null}
                                    {item.santraL_HIZMET_VERILEBILIRLIK
                                      ? ` - Santrale Mesafe yaklaşık 
                                      ${item.mesafe} Mt.`
                                      : null}
                                    {item.santraL_HIZMET_VERILEBILIRLIK &&
                                    item.fiber
                                      ? ` - Fiber`
                                      : null}
                                    {item.santraL_HIZMET_VERILEBILIRLIK &&
                                    item.boS_PORT
                                      ? ` - Boş Port bulunmaktadır`
                                      : null}
                                  </Typography>
                                </ListItem>
                                <Divider variant="inset" component="li" />
                              </>
                            )
                          )}
                        </List>
                      ) : null}
                    </>
                  ) : (
                    <CircularProgress />
                  )}
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
        <FormFooter />
      </PageLayout>
    </>
  );
};

const GetBBKCode = ({ setAddressNo }: any) => {
  const dispatch = useAppDispatch();
  const formik: any = useFormikContext();

  const getBBKCodeByDoorCode = async (doorCode: any) => {
    const result = await dispatch(
      ApiSlice.endpoints.get.initiate({
        resource: `fixity/setting/TurkTelekomAddress/get-address-no-by-bbk-code?doorCode=${doorCode}`,
        params: {
          ...params,
          filter: {
            doorCode,
          },
        },
      })
    );

    const { data: bbkCode }: any = result;
    formik.setFieldValue("addressDetail.bbkCode", bbkCode?.data?.kod);
    setAddressNo(bbkCode?.data?.addressNo);
  };

  useEffect(() => {
    if (formik.values.door.value) {
      getBBKCodeByDoorCode(formik.values.door.value);
    }
  }, [formik.values]);

  return null;
};

const GetInfrastructure = ({ infrastructure }: any) => {
  const { values, setFieldValue }: any = useFormikContext();
  useEffect(() => {
    if (values?.infrastructure === InfrastructureEnum.Pstn) {
      setFieldValue("devreNo", infrastructure);
    } else if (values?.infrastructure === InfrastructureEnum.Xdsl) {
      setFieldValue("phone", infrastructure);
    } else if (infrastructure === "") {
      setFieldValue("devreNo", "");
      setFieldValue("phone", "");
    }
  }, [values, setFieldValue, infrastructure]);

  return null;
};
export default Home;
